__turbopack_context__.v({
  "actions": "AbTestVariantPicker-module__YeGF7W__actions",
  "blurb": "AbTestVariantPicker-module__YeGF7W__blurb",
  "button": "AbTestVariantPicker-module__YeGF7W__button",
  "buttonPrimary": "AbTestVariantPicker-module__YeGF7W__buttonPrimary",
  "container": "AbTestVariantPicker-module__YeGF7W__container",
  "forced": "AbTestVariantPicker-module__YeGF7W__forced",
  "hideMenu": "AbTestVariantPicker-module__YeGF7W__hideMenu",
  "name": "AbTestVariantPicker-module__YeGF7W__name",
  "select": "AbTestVariantPicker-module__YeGF7W__select",
  "selectOn": "AbTestVariantPicker-module__YeGF7W__selectOn",
  "test": "AbTestVariantPicker-module__YeGF7W__test",
  "tests": "AbTestVariantPicker-module__YeGF7W__tests",
});
